import { HomeTasksItemController } from './home-tasks-item.controller'

function homeTasksItem () {
  return {
    restrict: 'E',
    scope: {
      task: '<'
    },
    templateUrl: '/home/directives/home-tasks-item/home-tasks-item-directive.html?$$REVISION$$',
    controller: HomeTasksItemController
  }
}

export { homeTasksItem }
